module.exports = __webpack_public_path__ + "static/media/iv_order_successfull.14c31cf9.svg";